import { useQuery } from 'react-query';
import axios from 'axios';
import { AuthContext } from '../../Context/AuthContext';
import { useContext } from 'react';

const fetchPendingUpdates = async (token) => {
  const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}/vesselOwner/profile/pendingUpdates`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

export const usePendingUpdates = () => {
  const { token } = useContext(AuthContext);

  return useQuery(
    ['pendingUpdates', token],
    () => fetchPendingUpdates(token),
    {
      enabled: !!token, 
    }
  );
};
